// Full-resolution images must never enter the catalog cache or Redux.
export function colorMetadata(color) {
  if (!color) return color;
  const { imageData, color: fullImage, ...metadata } = color;
  return metadata;
}
